import './Accordion.scss';
import React, { useState } from 'react';

import { ReactComponent as Arrow } from 'assets/arrow.svg';

const Accordion = ({
  title,
  titleContentType,
  body,
  bodyContentType
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return <div className="accordion">
      {titleContentType.includes('html') &&
        <button tabIndex="0"
                aria-expanded={isOpen}
                className="accordion-button"
                onClick={() => setIsOpen(!isOpen)}
                id={`accordion-header-${title}`}
                data-metrics-type="EC"
        >
          <Arrow aria-hidden={true}
                 className={isOpen ? 'open-arrow' : 'closed-arrow'}/>
          <div className="accordion-title"
               dangerouslySetInnerHTML={{ __html: title }} />
        </button>
      }
      {isOpen && bodyContentType.includes('html') &&
        <div className="accordion-body"
             dangerouslySetInnerHTML={{ __html: body }} />
      }
  </div>
};

export default Accordion;